export default {
    state: () => ({
        notifies: [
            {
                text: '',
                component: 'MobileAdvisePopup',
            },
        ],
    }),

    mutations: {
        setNotification: (state, notify) => {
            if (!notify.key) return;

            if (state.notifies.some((noty) => noty.key === notify.key)) {
                return;
            } else {
                state.notifies.splice(1, 0, notify);
            }
        },

        removeNotification: (state, i) => {
            let items = state.notifies.slice();
            items.splice(i, 1);
            state.notifies = items;
        },
    },

    actions: {
        addNotify: (ctx, notify) => {
            ctx.commit('setNotification', notify);
        },
        removeNotify: (ctx, i) => {
            ctx.commit('removeNotification', i);
        },
    },
};
